import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Loader2, Zap } from "lucide-react";
import api from "../../lib/api";
import MPlayShell, { VCard, SCard, Avatar, fmtViews } from "./VidShared";
import { useAuth } from "../../context/AuthContext";

export default function FollowingPage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("");

  useEffect(() => {
    if (user) api.get("/vid/following/feed").then((r) => setData(r.data)).catch(() => setData({ creators: [], videos: [] }));
  }, [user]);

  const videos = (data?.videos || []).filter((v) => tab === "Shorts" ? v.is_short : tab === "Videos" ? !v.is_short : true);

  if (!user) {
    return (
      <MPlayShell>
        <div className="flex flex-col items-center justify-center py-32 gap-4" data-testid="mplay-following-login">
          <Users className="h-12 w-12 text-emerald-400" />
          <p className="text-white font-extrabold text-xl">Follow creators to see their videos here</p>
          <p className="text-white/50 text-sm">Login to build your personal MPlay feed</p>
          <Link to="/mkt/auth?mode=login&returnTo=/videos/following" className="mp-green h-11 px-7 rounded-full text-sm font-extrabold inline-flex items-center" data-testid="following-login-btn">Sign in</Link>
        </div>
      </MPlayShell>
    );
  }

  return (
    <MPlayShell pills pillActive={tab} onPill={(p) => setTab(p)}>
      <div className="px-3 sm:px-6 pt-5 max-w-[1500px] mx-auto" data-testid="mplay-following">
        {!data ? <div className="py-24 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-400" /></div> : (
          <>
            {/* followed creators avatar rail */}
            <div className="flex gap-5 overflow-x-auto mp-scroll pb-2 -mx-1 px-1" data-testid="mplay-following-rail">
              {data.creators.length === 0 && (
                <p className="text-white/50 text-sm py-4">You are not following anyone yet — open a video and tap <span className="text-emerald-400 font-bold">Follow</span>.</p>
              )}
              {data.creators.map((c) => (
                <div key={c.id} className="flex flex-col items-center gap-1.5 shrink-0 w-[72px]" data-testid={`mp-follow-creator-${c.id}`}>
                  <span className="rounded-full p-[2.5px]" style={{ background: "linear-gradient(135deg,#4ade80,#16a34a)" }}>
                    <span className="block rounded-full bg-[#070b09] p-[2px]"><Avatar name={c.name} size={52} /></span>
                  </span>
                  <span className="text-white/80 text-[11px] font-bold truncate w-full text-center">{c.name.split(" ")[0]}</span>
                </div>
              ))}
            </div>

            <div className="flex gap-2 mt-5">
              {["", "Videos", "Shorts"].map((t) => (
                <button key={t || "all"} onClick={() => setTab(t)} data-testid={`mp-following-tab-${(t || "all").toLowerCase()}`}
                  className={`mp-pill ${tab === t ? "on" : ""}`}>{t || "All"}</button>
              ))}
            </div>

            {videos.length === 0 ? (
              <p className="text-white/40 text-sm py-20 text-center">No videos from followed creators yet.</p>
            ) : tab === "Shorts" ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mt-5">
                {videos.map((v) => <SCard key={v.id} v={v} />)}
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-4 gap-y-8 mt-5">
                {videos.map((v) => <VCard key={v.id} v={v} />)}
              </div>
            )}
          </>
        )}
      </div>
    </MPlayShell>
  );
}
